import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InventoryToolTipMessaging } from '@inventory/models/edit-inventory.model';
import { InventoryQuantityUpdate } from '@inventory/models/inventory-quantity.model';
import { InventoryProductViewModel } from '@inventory/models/inventory-view.model';
import { PlatformEnum } from '@panamax/app-state';
import { DecimalCustomBorders } from '@shared/constants/inventory-constants';

@Component({
  selector: 'app-inventory-count-card',
  templateUrl: './inventory-count-card.component.html',
  styleUrls: ['./inventory-count-card.component.scss'],
})
export class InventoryCountCardComponent {
  readonly PlatformEnum = PlatformEnum;

  @Input() platform: PlatformEnum;
  @Input() inventoryId: string;
  @Input() inventoryItem: InventoryProductViewModel;
  @Input() index: number;
  @Input() isOnline: boolean;

  @Output()
  updateQuantityEvent: EventEmitter<InventoryQuantityUpdate> = new EventEmitter();
  @Output()
  productDescriptionClick: EventEmitter<InventoryProductViewModel> = new EventEmitter();
  @Output()
  toolTipHoverEvent: EventEmitter<InventoryToolTipMessaging> = new EventEmitter();
  @Output()
  toolTipLeaveEvent: EventEmitter<void> = new EventEmitter();
  @Output()
  itemForInformationEvent: EventEmitter<InventoryProductViewModel> = new EventEmitter();

  readonly borderRef = DecimalCustomBorders;

  constructor() {}

  handleCaseUpdate = (value: any) => {
    if (this.inventoryItem.caseOnHand.currentValue !== value.quantity) {
      this.updateQuantityEvent.emit({
        isCount: true,
        inventoryItemId: this.inventoryItem?.productNumber,
        inventoryId: this.inventoryId,
        groupName: this.inventoryItem?.groupName,
        isCase: true,
        value: value.quantity,
      } as InventoryQuantityUpdate);
    }
  };

  handleEachUpdate = (value: any) => {
    if (this.inventoryItem.eachOnHand.currentValue !== value.quantity) {
      this.updateQuantityEvent.emit({
        isCount: true,
        inventoryItemId: this.inventoryItem?.productNumber,
        inventoryId: this.inventoryId,
        groupName: this.inventoryItem?.groupName,
        isCase: false,
        value: value.quantity,
      } as InventoryQuantityUpdate);
    }
  };

  handleProductDescriptionClick() {
    this.productDescriptionClick.emit(this.inventoryItem);
  }

  async handleCatchWeightHover(event$: Event) {
    if (this.inventoryItem.productCatchWeightFlag) {
      this.toolTipHoverEvent.emit({
        event$: event$,
        isCatchWeightWarning: true,
      });
    }
  }

  async handleCatchWeightLeave() {
    if (this.inventoryItem.productCatchWeightFlag) {
      this.toolTipLeaveEvent.emit();
    }
  }

  async handleInfoIconClick() {
    this.itemForInformationEvent.emit(this.inventoryItem);
  }
}
